import React from 'react';
import Slider from 'rc-slider';

import styles from './PriceRange.module.css';

interface Props {
  steps: number[];
  lower?: number;
  upper?: number;
  onChange: (lower: number, higher: number) => void;
  onAfterChange: (lower: number, higher: number) => void;
}

function findIndexOrDefault<T>(arr: T[], target: T, dfault: number): number {
  const index = arr.findIndex((item) => item === target);
  return index > -1 ? index : dfault;
}

export class PriceRange extends React.PureComponent<Props> {
  private onChange = (value: number | number[]) => {
    if (Array.isArray(value)) {
      const [lower, upper] = value;
      this.props.onChange(this.props.steps[lower], this.props.steps[upper]);
    }
  };

  private onChangeComplete = (value: number | number[]) => {
    if (Array.isArray(value)) {
      const [lower, upper] = value;
      this.props.onAfterChange(
        this.props.steps[lower],
        this.props.steps[upper]
      );
    }
  };

  public render(): React.ReactNode {
    const { lower, upper, steps } = this.props;

    return (
      <div className={styles.container}>
        <Slider
          range
          value={[
            findIndexOrDefault(steps, lower, 0),
            findIndexOrDefault(steps, upper, steps.length),
          ]}
          tabIndex={[0, 1]}
          min={0}
          max={steps.length - 1}
          pushable={2}
          onChange={this.onChange}
          onChangeComplete={this.onChangeComplete}
        />
      </div>
    );
  }
}
